import { render } from "./table-pra_pelaksanaan_tahapan_diklat.vue?vue&type=template&id=54684b19&scoped=true"
import script from "./table-pra_pelaksanaan_tahapan_diklat.vue?vue&type=script&lang=js"
export * from "./table-pra_pelaksanaan_tahapan_diklat.vue?vue&type=script&lang=js"

import "./table-pra_pelaksanaan_tahapan_diklat.vue?vue&type=style&index=0&id=54684b19&lang=css"
import "./table-pra_pelaksanaan_tahapan_diklat.vue?vue&type=style&index=1&id=54684b19&scoped=true&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54684b19"]])

export default __exports__